//remove default shopify class
let page_container = document.getElementById('PageContainer')
if(page_container)
page_container.classList.remove('page-container')

//Get Banners, Diamond list, Wrapper
let root = document.querySelector(':root');

let extra = 0
let main_content = document.getElementById('MainContent')
main_content.style.paddingTop = '0px'
let wrapper = document.getElementById('Customize-Wrapper')

let diamond_list = document.getElementById('Diamond-List-Container')
// //NEW NAV
let new_nav_total = 58.5

root.style.setProperty('--navHeight', new_nav_total + 'px');


let url = new URL(location.href)
let name = url.searchParams.get('name')

let shape = url.searchParams.get('shape')
let size = url.searchParams.get('size')
let metal = url.searchParams.get('metal')
let ring_img = url.searchParams.get('ring_img')
let engravings = url.searchParams.get('engravings')
let handle = url.searchParams.get('handle')
let d1 = url.searchParams.get('d1')
let d2 = url.searchParams.get('d2')
let main_is_all_cut = false
let diamond_type = url.searchParams.get('natural')


//NAV
document.getElementById('Customize-Go-Back-Btn').addEventListener('click',()=>{
  if(main_is_all_cut){
    location.href = '/'
  } else{
    location.href = '/products/'+ handle +'?metal=' + metal +'&size=' + size + '&engravings=' + encodeURIComponent(engravings) + '&modify=Y'
  }
})

